import React from 'react';
import Nav from '../../SharedComp/Nav/Nav';
import './Page404.css';

const Page404 = () => {
    return (
        <div style={{ textAlign: 'center' }}>
            <Nav></Nav>
            <div className='page404'>
                <h1>404</h1>
                <h2>Page Not Found</h2>
            </div>
        </div>
    );
};

export default Page404;